import {createSelector} from 'reselect';

const selectShowroomState = (state) => state.showroom;

// Events
export const makeSelectShowroomEvents = () =>
  createSelector(selectShowroomState, (state) => state.events);
export const makeSelectShowroomEventsFetching = () =>
  createSelector(selectShowroomState, (state) => state.eventsFetching);
export const makeSelectShowroomEventsTotal = () =>
  createSelector(selectShowroomState, (state) => state.eventsTotal);
export const makeSelectShowroomEventsFailed = () =>
  createSelector(selectShowroomState, (state) => state.eventsFailed);
export const makeSelectShowroomEventsError = () =>
  createSelector(selectShowroomState, (state) => state.eventsError);

// Current Event
export const makeSelectShowroomCurrentEvent = () =>
  createSelector(selectShowroomState, (state) => state.currentEvent);
export const makeSelectShowroomCurrentEventFetching = () =>
  createSelector(selectShowroomState, (state) => state.currentEventFetching);
export const makeSelectShowroomCurrentEventSuccess = () =>
  createSelector(selectShowroomState, (state) => state.currentEventSuccess);
export const makeSelectShowroomCurrentEventFailed = () =>
  createSelector(selectShowroomState, (state) => state.currentEventFailed);
export const makeSelectShowroomCurrentEventError = () =>
  createSelector(selectShowroomState, (state) => state.currentEventError);

// Members
export const makeSelectShowroomMembers = () =>
  createSelector(selectShowroomState, (state) => state.members);
export const makeSelectShowroomMembersFetching = () =>
  createSelector(selectShowroomState, (state) => state.membersFetching);
export const makeSelectShowroomMembersTotal = () =>
  createSelector(selectShowroomState, (state) => state.membersTotal);

// Viewers
export const makeSelectShowroomViewers = () =>
  createSelector(selectShowroomState, (state) => state.viewers);
export const makeSelectShowroomViewersFetching = () =>
  createSelector(selectShowroomState, (state) => state.viewersFetching);
export const makeSelectShowroomViewersTotal = () =>
  createSelector(selectShowroomState, (state) => state.viewersTotal);
export const makeSelectShowroomViewersWatchStats = () =>
  createSelector(selectShowroomState, (state) => state.viewersWatchStats);

// Access Requests
export const makeSelectShowroomAccessRequests = () =>
  createSelector(selectShowroomState, (state) => state.accessRequests);
export const makeSelectShowroomAccessRequestsFetching = () =>
  createSelector(selectShowroomState, (state) => state.accessRequestsFetching);
export const makeSelectShowroomAccessRequestsFailed = () =>
  createSelector(selectShowroomState, (state) => state.accessRequestsFailed);

// Chat Messages
export const makeSelectShowroomChatMessages = () =>
  createSelector(selectShowroomState, (state) => state.chatMessages);
export const makeSelectShowroomChatMessagesFetching = () =>
  createSelector(selectShowroomState, (state) => state.chatMessagesFetching);

// Eligibility
export const makeSelectShowroomEligibility = () =>
  createSelector(selectShowroomState, (state) => state.eligibility);
export const makeSelectShowroomEligibilityFetching = () =>
  createSelector(selectShowroomState, (state) => state.eligibilityFetching);
export const makeSelectShowroomEligibilityFailed = () =>
  createSelector(selectShowroomState, (state) => state.eligibilityFailed);
export const makeSelectShowroomEligibilityError = () =>
  createSelector(selectShowroomState, (state) => state.eligibilityError);

// Pricing Packages
export const makeSelectShowroomPricingPackages = () =>
  createSelector(selectShowroomState, (state) => state.pricingPackages);
export const makeSelectShowroomPricingPackagesFetching = () =>
  createSelector(selectShowroomState, (state) => state.pricingPackagesFetching);
export const makeSelectShowroomPricingPackagesSuccess = () =>
  createSelector(selectShowroomState, (state) => state.pricingPackagesSuccess);
export const makeSelectShowroomPricingPackagesFailed = () =>
  createSelector(selectShowroomState, (state) => state.pricingPackagesFailed);
export const makeSelectShowroomPricingPackagesUpdating = () =>
  createSelector(selectShowroomState, (state) => state.pricingPackagesUpdating);
export const makeSelectShowroomPricingPackagesError = () =>
  createSelector(selectShowroomState, (state) => state.pricingPackagesError);
export const makeSelectShowroomPricingPackagesUpdateFailed = () =>
  createSelector(
    selectShowroomState,
    (state) => state.pricingPackagesUpdateFailed
  );
export const makeSelectShowroomPricingPackagesUpdateError = () =>
  createSelector(
    selectShowroomState,
    (state) => state.pricingPackagesUpdateError
  );

// UI State
export const makeSelectShowroomActiveTab = () =>
  createSelector(selectShowroomState, (state) => state.activeTab);

// Admin Review
export const makeSelectShowroomReviewSubmitting = () =>
  createSelector(selectShowroomState, (state) => state.reviewSubmitting);
export const makeSelectShowroomReviewSuccess = () =>
  createSelector(selectShowroomState, (state) => state.reviewSuccess);
export const makeSelectShowroomReviewFailed = () =>
  createSelector(selectShowroomState, (state) => state.reviewFailed);
export const makeSelectShowroomReviewError = () =>
  createSelector(selectShowroomState, (state) => state.reviewError);
export const makeSelectShowroomEventDeleteSubmitting = () =>
  createSelector(selectShowroomState, (state) => state.eventDeleteSubmitting);
export const makeSelectShowroomEventDeleteSuccess = () =>
  createSelector(selectShowroomState, (state) => state.eventDeleteSuccess);
export const makeSelectShowroomEventDeleteFailed = () =>
  createSelector(selectShowroomState, (state) => state.eventDeleteFailed);
export const makeSelectShowroomEventDeleteError = () =>
  createSelector(selectShowroomState, (state) => state.eventDeleteError);
